"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TwoWayBinding_1 = __importDefault(require("../Mixins/TwoWayBinding"));
exports.default = {
    props: {
        name: { type: String, required: true },
        value: [String, Number, Boolean],
        label: String,
        picked: [String, Number, Boolean],
        required: Boolean,
        default: [String, Number, Boolean],
    },
    mixins: [TwoWayBinding_1.default],
    model: {
        prop: 'picked'
    },
    methods: {
        onChange: function ($event) {
            this.$emit('input', JSON.parse($event.target.value));
        }
    },
    computed: {
        internalPicked: {
            get: function () {
                return JSON.stringify(this.internalValue);
            },
            // setter
            set: function (newValue) {
                this.update(JSON.parse(newValue));
            }
        }
    },
    beforeMount: function () {
        if (this.picked === this.value) {
            this.update(this.value);
        }
    },
    beforeDestroy: function () {
        this.update(this.default);
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/RadioInput.vue
// module id = 228
// module chunks = 0